import { FC } from 'react'

import { Box } from '@mui/material'

import { TableSkeleton } from '../TableSkeleton/TableSkeleton'

/**
 * Default initial-load placeholder for a ua-insights detail dialog, used by
 * `UAInsightsDialog` whenever a caller does not supply its own layout-matched
 * `loadingPlaceholder`. Renders a neutral table-shaped skeleton (rather than a
 * centred spinner) so the dialog reads as "rendering" instead of "blocked on a
 * fetch" and the paper does not visibly resize when data arrives.
 */
export const DialogLoader: FC = () => (
  <Box sx={{ flex: 1 }}>
    <TableSkeleton rows={8} columns={5} bare />
  </Box>
)
